import * as React from 'react';

import PropTypes from 'prop-types';

import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import IsMobileScreenContext from 'bundles/page/contexts/IsMobileScreenContext';
import LearnerProvider from 'bundles/search-common/providers/LearnerProvider';
import withMarketingScripts from 'bundles/seo/components/hoc/withMarketingScripts';
import useMobileScreen from 'bundles/unified-seo-content-common/utils/useMobileScreen';

import 'css!bundles/unified-seo-content-common/styl/index';

type Store = $TSFixMe;

type Context = {
  getStore: (name: string) => Store;
};

type Props = {
  children?: JSX.Element;
};

const SEOContentPageWrapper = ({ children }: Props, { getStore }: Context) => {
  const isMobileScreenInfo = useMobileScreen(getStore('ApplicationStore').getUserAgent());
  return (
    <IsMobileScreenContext.Provider value={isMobileScreenInfo}>
      <div style={{ minHeight: '100vh', backgroundColor: 'white' }}>
        <PageHeader showLanguagesDropdown />
        <LearnerProvider>
          <div>{children}</div>
        </LearnerProvider>
        <PageFooter />
      </div>
    </IsMobileScreenContext.Provider>
  );
};

SEOContentPageWrapper.contextTypes = {
  getStore: PropTypes.func.isRequired,
};

export default withMarketingScripts(SEOContentPageWrapper);
